import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard shadcn/ui helper: merges class strings while letting later
// Tailwind utilities override earlier ones predictably.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
